import { render, staticRenderFns } from "./volunteer-activities.vue?vue&type=template&id=5dda019c&"
import script from "./volunteer-activities.vue?vue&type=script&lang=js&"
export * from "./volunteer-activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports